import { Store } from "redux";
import { observeStore } from "./utils";

export class AdditionalCosts {
  elements: NodeListOf<HTMLElement>;
  store: Store;

  constructor(selector: string, store: Store) {
    this.elements = document.querySelectorAll(selector);

    if (!this.elements || this.elements.length === 0) return;

    this.store = store;
    this.bindEvents();
  }

  bindEvents() {
    observeStore(this.store, (state) => (state as any).delivery, this.handleStoreChange);
  }

  handleStoreChange = (delivery) => {
    if (!delivery) return;

    this.elements.forEach((element) => {
      element.innerHTML = String(delivery.cost.toFixed(2));
    });
  };
}
